export default "__VITE_ASSET__B3hx4QWj__"